import confetti from "canvas-confetti";

const COLORS = ["#FF5A5F", "#00B4D8", "#FFC107", "#A7C957", "#7B3F9F"];

export function celebrate() {
  const duration = 2200;
  const end = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 4,
      angle: 60,
      spread: 65,
      startVelocity: 55,
      origin: { x: 0, y: 0.7 },
      colors: COLORS,
    });
    confetti({
      particleCount: 4,
      angle: 120,
      spread: 65,
      startVelocity: 55,
      origin: { x: 1, y: 0.7 },
      colors: COLORS,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  frame();
}

export function bigWin() {
  confetti({
    particleCount: 180,
    spread: 120,
    startVelocity: 45,
    origin: { y: 0.6 },
    colors: COLORS,
  });
  setTimeout(() => {
    confetti({
      particleCount: 100,
      spread: 160,
      origin: { y: 0.5 },
      colors: COLORS,
    });
  }, 300);
}
